/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-05 10:29:30
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import ElseSnConfigApi, { ElseSnConfigDOI } from './api/elseSnConfigApi';
 import { Integer } from 'src/types/base';
 import { createNamespace } from 'src/util/bem';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import EnumOperates from 'src/enums/enumOperates';
 import RegexCheck from 'src/util/regexCheck';
 import IconCustom from 'src/components/icon/iconCustom';
 import EnumPermission from 'src/enums/enumPermission';

 export namespace ElseSnOperateVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        user_name: string;
        user_phone: string;
        lower_computer_permission:Number;
    }
 }

 @Component
 class ElseSnOperateModal extends Vue.Component<ElseSnOperateVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: ElseSnOperateVOI.FormDataI = {
        user_name: '',
        user_phone: '',
        lower_computer_permission: null,
    };

    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params: ElseSnConfigDOI.OperateParamsI = {
            ...this.formData,
        };
        params.id = this.id;
        res = await ElseSnConfigApi.update(params);
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success("修改成功");
            this.saveSuccess();
            this.closeModal();
        }
    }
    
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={"修改"}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
                footer-hide={EnumOperates.Detail.getName()===this.operate}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="客户姓名" prop="user_name" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.user_name} />
                    </form-item>
                    <form-item label="手机号" prop="user_phone" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.user_phone} />
                    </form-item>
                    <form-item label="下位机权限" prop="lower_computer_permission" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumPermission.getList() as any} v-model={this.formData.lower_computer_permission} placeholder="请输入" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
 }


 export default function alertElseSnOperateModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ElseSnOperateVOI.PropsI>(ElseSnOperateModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
 }


